<template>
    <div class="collapsible">
        <h6 class="collapsible-title" @click="togglePanel">{{ title }} <i class="fas fa-caret-down" :class="{open:isOpen}" ></i></h6>
        <transition name="expand"
                    @enter="enter"
                    @after-enter="afterEnter"
                    @leave="leave">
            <div v-if="isOpen" ref="content" class="collapsible-content" :class="{'collapsible-standard':!isFloating,'collapsible-floating':isFloating}">
                <slot></slot>
            </div>
        </transition>
    </div>
</template>

<script>
    export default {
        name: "Collapsible",
        props:{
            title:String,
            isFloating:{
                type:Boolean,
                default: false
            },
            startsOpen:{
                type:Boolean,
                default: false
            }
        },

        data() {
            return {
                isOpen:false
            };
        },
        mounted() {
            this.isOpen = this.startsOpen;
        },
        methods:{
            togglePanel(){
                this.isOpen = !this.isOpen;
            },
            enter(element) {
                const width = getComputedStyle(element).width;

                element.style.width = width;
                element.style.position = 'absolute';
                element.style.visibility = 'hidden';
                element.style.height = 'auto';

                const height = getComputedStyle(element).height;

                element.style.width = null;
                element.style.position = null;
                element.style.visibility = null;
                element.style.height = 0;
                getComputedStyle(element).height;
                setTimeout(() => {
                    element.style.height = height;
                });
            },
            afterEnter(element) {
                element.style.height = 'auto';
            },
            leave(element) {
                const height = getComputedStyle(element).height;

                element.style.height = height;
                getComputedStyle(element).height;

                setTimeout(() => {
                    element.style.height = 0;
                });
            }
        }
    }
</script>

<style scoped>
    .collapsible-content {
        will-change: height;
        transform: translateZ(0);
        backface-visibility: hidden;
        perspective: 1000px;
    }
</style>
